import type { ApolloClient } from "@apollo/client";
import type { ImagingAssetKind } from "elephant-web/gql";
import { EpocusGenerateImagingAssetUrlDocument } from "./__generated__/use-epocus-exam-images.gql";

/**
 * Resolves to null while a cine is still transcoding — the Apollo type policy
 * for this field deliberately does not cache a null url, so a later call picks
 * the artifact up as soon as it lands.
 */
export const fetchImagingAssetUrl = async (
  apolloClient: ApolloClient<object>,
  imagingInstanceId: string,
  kind: ImagingAssetKind,
  { bypassCache = false }: { bypassCache?: boolean } = {},
): Promise<string | null> => {
  const result = await apolloClient.query({
    query: EpocusGenerateImagingAssetUrlDocument,
    variables: { input: { imagingInstanceId, kind } },
    fetchPolicy: bypassCache ? "network-only" : "cache-first",
  });
  return result.data?.generateImagingAssetUrl?.url ?? null;
};
